export interface AssetPreset {
    name: string;
    symbol: string;
    type: string;
}

export const ASSET_PRESETS: Record<string, AssetPreset> = {
    USD:  { name: "USD",      symbol: "$",    type: "FIAT"   },
    USDT: { name: "USDT",     symbol: "USDT", type: "CRYPTO" },
    BTC:  { name: "Bitcoin",  symbol: "BTC",  type: "CRYPTO" },
    ETH:  { name: "Ethereum", symbol: "ETH",  type: "CRYPTO" },
};

export const findExistingAsset = (
    input: { name: string; symbol: string },
    existingAssets: { 
        name: string; 
        symbol: string; 
        type: string 
    }[]): { 
        name: string; 
        symbol: string; 
        type: string 
    } | null => {
    const typedSymbol = input.symbol.trim().toUpperCase();
    const typedName = input.name.trim().toUpperCase();

    const pool = [...Object.values(ASSET_PRESETS), ...existingAssets];

    return pool.find((asset) =>
        asset.symbol.toUpperCase() === typedSymbol ||
        asset.name.toUpperCase() === typedName
    ) ?? null;
};